module.exports = __webpack_public_path__ + "media/application/images/svgs/folder-2fd4a343a47edf3a78710d7011802b96.svg";